import i18n from 'i18n/config';

/**
 * Regular expression for basic email validation.
 */
export const validateEmailPattern = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

/**
 * Validates the email field and returns an error string if invalid, or null if valid.
 */
export const validateEmailField = (email: string): string | null => {
  if (!email) return i18n.t('validation.emailRequired', 'Email is required');
  if (!validateEmailPattern(email))
    return i18n.t('validation.emailInvalid', 'Please enter a valid email address');
  return null;
};

/**
 * Validates the login identifier (email or username) field.
 */
export const validateLoginIdentifier = (identifier: string): string | null => {
  if (!identifier)
    return i18n.t('validation.loginIdentifierRequired', 'Email or username is required');
  if (identifier.length <= 3)
    return i18n.t('validation.loginIdentifierLength', 'Must be longer than 3 characters');
  return null;
};

/**
 * Validates the username field and returns an error string if invalid, or null if valid.
 */
export const validateUsernameField = (username: string): string | null => {
  if (!username) return i18n.t('validation.usernameRequired', 'Username is required');
  if (username.includes('@'))
    return i18n.t('validation.usernameNoAt', 'Username cannot contain the @ symbol');
  if (/\s/.test(username))
    return i18n.t('validation.usernameNoSpaces', 'Username cannot contain spaces');
  return null;
};

/**
 * Validates the password field and returns an error string if invalid, or null if valid.
 */
export const validatePasswordField = (password: string): string | null => {
  if (!password) return i18n.t('validation.passwordRequired', 'Password is required');
  if (password.length < 8)
    return i18n.t('validation.passwordMinLength', 'Minimum character length is 8');
  return null;
};

/**
 * Validates the confirm password field against the original password.
 */
export const validateConfirmPassword = (password: string, confirm: string): string | null => {
  if (!confirm) return i18n.t('validation.confirmPasswordRequired', 'Please confirm your password');
  if (password !== confirm)
    return i18n.t('validation.passwordsDoNotMatch', 'Passwords do not match');
  return null;
};
